import { I4BCellType, I4BColumnConfiguration, I4BColumnRowGroupConfiguration } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType, I4BColumnHeader } from '../models';
import { I4BVariableColumnOptions } from '../options';
import { DaliaModeDateTimeColumn } from './dalia-mode-date-time.column';
import { DaliaModeValueColumn } from './dalia-mode-value.column';
import { I4BBasicColumn } from './i4b-basic.column';

interface DiagnosticVariableGroupColumnConfiguration extends I4BColumnConfiguration {
  rowGroupParams: Partial<{
    value: Partial<I4BColumnRowGroupConfiguration>;
    dateTime: Partial<I4BColumnRowGroupConfiguration>;
  }>;
}

export class DaliaModeGroupColumn extends I4BBasicColumn {
  columnId = 'a034bd54-9fc3-11ec-9da8-1123a40210d0-dalia-mode-group';
  className = DaliaModeGroupColumn;

  constructor(
    customHeader?: Partial<I4BColumnHeader>,
    customConfig?: Partial<DiagnosticVariableGroupColumnConfiguration>,
    customOptions?: Partial<I4BVariableColumnOptions>
  ) {
    super(
      {
        ...customHeader,
        displayName: customOptions?.overrideHeaderName ? customOptions?.overrideHeaderName : customHeader?.displayName ? customHeader?.displayName : 'VARIABLE',
        type: HeaderType.BASIC
      },
      {
        cell: { ...customConfig?.cell, type: I4BCellType.BASIC },
        id: customConfig?.id,
        concept: I4bCellConcept.DIAGNOSTIC_VARIABLES,
        isDefault: !!customConfig?.isDefault,
        marryChildren: true,
        rowGroupParams: customConfig?.rowGroupParams,
        children: [
          new DaliaModeValueColumn(
            { displayName: 'VALUE' },
            {
              id: 'expandedVariables',
              isDefault: true,
              cell: {
                ...customConfig?.cell,
                type: I4BCellType.BASIC,
                options: {
                  ...customConfig?.cell?.options
                }
              },
              rowGroupParams: customConfig?.rowGroupParams?.value
            },
            { order: 0, isDisplayed: true }
          ),
          new DaliaModeDateTimeColumn(
            { displayName: 'DATETIME' },
            {
              id: 'expandedVariables',
              isDefault: false,
              cell: {
                type: I4BCellType.DATE
              },
              width: 170,
              rowGroupParams: customConfig?.rowGroupParams?.dateTime
            },
            { order: 1, isDisplayed: customOptions?.displayDateTime }
          )
        ]
      },
      { displayDateTime: customOptions?.displayDateTime, ...customOptions }
    );
  }
}
